module.exports = new __parcel__URL__("trash.a4bf000c.svg").toString();